
// import { Drawer } from "element-ui"
// import { initBindCardSource } from "./checkout/bind-card.js"
// import bindCard from "./checkout/bind-card.vue"
// import drawerHeader from "./drawer/components/drawerHeader.vue"
import { cardList, unbindCard } from "@/api/pay.js"
import bindCardMixin from "@/mixins/bindCard"

export default {
  components: {
    // [Drawer.name]: Drawer,
    // bindCard,
    // drawerHeader
  },
  mixins: [bindCardMixin],
  data() {
    return {
      loading: false,
      cardList: []
      // visible: false,
      // bindCardStatus: "init"
    }
  },
  computed: {
    // btnText() {
    //   return this.bindCardStatus === "init" ? this.$t("checkout.next") : this.$t("checkout.payNow")
    // },
    // cardTitle() {
    //   let title = ""
    //   if (this.bindCardStatus === "init") {
    //     title = this.$t("checkout.addNewCard")
    //   } else if (this.bindCardStatus === "beforeVerify") {
    //     title = this.$t("checkout.orderReview")
    //   } else if (this.bindCardStatus === "verifying") {
    //     title = this.$t("checkout.DSecureAuth")
    //   }
    //   return title
    // }
  },
  mounted() {
    const bindCardResult = localStorage.getItem("bindcard_result")
    if (bindCardResult === "success") {
      this.$message({
        message: this.$t("checkout.bindCardSuccess"),
        type: "success"
      })
    } else if (bindCardResult === "fail") {
      this.$message({
        message: this.$t("checkout.bindCardFail"),
        type: "error"
      })
    }
    localStorage.removeItem("bindcard_result")
    this.getCardList()
  },
  methods: {
    handleAddCard() {
      // this.loading = true
      // // await initBindCardSource()
      // this.visible = true
      // this.loading = false
      this.bindCard()
    },
    async getCardList() {
      const { data } = await cardList({
        params: JSON.stringify({
          payWay: 900
        })
      })
      this.cardList = data || []
    },
    // handleDrawerClose() {
    //   this.bindCardStatus = "init"
    // },
    // handleSave() {
    //   this.$refs.bindCard.onSubmit()
    // },
    // handleStatuChanged({ status, payload }) {
    //   this.bindCardStatus = status
    //   if (status === "done") {
    //     this.visible = false
    //     this.bindCardStatus = "init"
    //     this.getCardList()
    //   }
    //   if (status === "error") {
    //     this.visible = false
    //     this.bindCardStatus = "init"
    //   }
    // },
    handleDelete(signNum) {
      this.$messageBox
        .open({
          title: this.$t("card.deleteCard"),
          message: this.$t("card.confirmText"),
          cancelText: this.$t("card.cancel"),
          confirmText: this.$t("card.confirm")
        })
        .then(res => {
          this.unbindCard(signNum)
        })
        .catch(res => {})
    },
    async unbindCard(signNum) {
      try {
        const { data } = await unbindCard({
          params: JSON.stringify({
            payWay: 900,
            signNum
          })
        })
        this.$message.success(this.$t("card.message"))
        this.getCardList()
      } catch (error) {
        console.log(error)
      }
    }
  }
}
